// The last story and the first benefit share a reversible, two-section handoff.
export function createFomoSectionTransition({
  frame,
  sticky,
  incoming,
  header,
  isStill,
}) {
  const clamp = (x) => Math.max(0, Math.min(1, x));
  const ease = (x) => x * x * (3 - 2 * x);
  let chapter = -1;
  function prepare(next) {
    chapter = next;
  }

  function pose(node, scale, y) {
    node.style.transform = `translateY(${y.toFixed(2)}px) scale(${scale.toFixed(
      4
    )})`;
    node.style.setProperty("--frame-edge", ((1 - scale) * 2).toFixed(4));
    node.style.borderRadius = `${Math.max(0, (1 - scale) * 80).toFixed(2)}px`;
  }

  function update(phase) {
    const leave =
      chapter === 3 && !isStill() ? ease(clamp((phase - 0.84) / 0.16)) : 0;
    pose(frame, 1 - leave * 0.54, -sticky.clientHeight * leave * 0.255);
    if (!leave) {
      pose(incoming, 1, 0);
      return;
    }

    // Read the untransformed track so the incoming section never feeds its
    // animated position back into the scroll calculation. No clone is needed.
    const trackTop = incoming.parentElement.getBoundingClientRect().top;
    const headerHeight = header.offsetHeight;
    const height = incoming.clientHeight;
    const arrival = ease(
      clamp((innerHeight - trackTop) / Math.max(1, innerHeight - headerHeight))
    );
    const scale = 0.46 + arrival * 0.54;
    const pairedTop = headerHeight + sticky.clientHeight * 0.505;
    const targetTop =
      (innerHeight + 32) * (1 - leave) +
      (headerHeight + (pairedTop - headerHeight) * (1 - arrival)) * leave;
    const naturalTop = Math.max(headerHeight, trackTop);
    pose(incoming, scale, targetTop - naturalTop - ((1 - scale) * height) / 2);
  }

  return {
    prepare,
    update,
    destroy() {
      pose(frame, 1, 0);
      pose(incoming, 1, 0);
    },
  };
}
